export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ08.93a66044.mp3";